import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";

/**
 * MailKundenSuche (A-010 M3, 16.10.2026) — Kunde eintippen und auswählen (Name, Firma, Mail, Telefon, Ort).
 * Für „Neue Mail“ und „Bestehendem Kunden zuordnen“ in der Mail-Zentrale.
 * Props: { onWaehle(kunde), placeholder?, autoFocus?, testid? }
 */
let _kundenCache = null;
let _kundenZeit = 0;
export const kundenLaden = async (neu = false) => {
  if (!neu && _kundenCache && Date.now() - _kundenZeit < 60000) return _kundenCache;
  const r = await api.get("/modules/kunden/data");
  _kundenCache = Array.isArray(r.data) ? r.data : [];
  _kundenZeit = Date.now();
  return _kundenCache;
};

export const kundeAnzeigename = (k) =>
  (k?.firma || [k?.vorname, k?.nachname].filter(Boolean).join(" ") || k?.name || "(ohne Name)");

const MailKundenSuche = ({ onWaehle, placeholder = "Kunde suchen (Name, Mail, Telefon, Ort)…", autoFocus = false, testid = "mail-kunden-suche" }) => {
  const [kunden, setKunden] = useState([]);
  const [q, setQ] = useState("");
  const [offen, setOffen] = useState(false);

  useEffect(() => {
    kundenLaden().then(setKunden).catch(() => setKunden([]));
  }, []);

  const t = q.trim().toLowerCase();
  const treffer = t.length < 2 ? [] : kunden.filter((k) =>
    [kundeAnzeigename(k), k.name, k.email, k.phone, k.mobile, k.ort, k.strasse]
      .filter(Boolean).join(" ").toLowerCase().includes(t)
  ).slice(0, 8);

  return (
    <div className="relative" data-testid={testid}>
      <div className="flex items-center gap-1 border border-input rounded-sm px-2 bg-background">
        <Search className="w-3.5 h-3.5 text-muted-foreground" />
        <input
          className="w-full py-1.5 text-sm bg-transparent outline-none"
          value={q}
          autoFocus={autoFocus}
          placeholder={placeholder}
          onChange={(e) => { setQ(e.target.value); setOffen(true); }}
          onFocus={() => setOffen(true)}
          data-testid={`${testid}-eingabe`}
        />
      </div>
      {offen && treffer.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-background border rounded-sm shadow-lg max-h-64 overflow-auto">
          {treffer.map((k) => (
            <button
              type="button"
              key={k.id}
              className="w-full text-left px-2 py-1.5 text-sm hover:bg-accent"
              onClick={() => { onWaehle?.(k); setQ(kundeAnzeigename(k)); setOffen(false); }}
              data-testid={`${testid}-treffer-${k.id}`}
            >
              <div className="font-medium truncate">{kundeAnzeigename(k)}</div>
              <div className="text-xs text-muted-foreground truncate">{[k.email, k.phone, k.ort].filter(Boolean).join(" · ") || "—"}</div>
            </button>
          ))}
        </div>
      )}
      {offen && t.length >= 2 && treffer.length === 0 && (
        <div className="absolute z-50 mt-1 w-full bg-background border rounded-sm shadow p-2 text-xs text-muted-foreground">Kein Kunde gefunden.</div>
      )}
    </div>
  );
};

export default MailKundenSuche;
